import { reactive } from 'vue'
import * as appTypes from '@/store/actions/app'
import languages from './languages'
const merge = (...objs) => Object.assign({}, ...objs)

const clientLanguage = process.env.CLIENT_LANGUAGE || {}

// Merge app languages with client-specific overrides
const mergedLanguages = {}
;['es_ES', 'en_GB', 'ca_ES'].forEach(locale => {
  mergedLanguages[locale] = merge(
    languages[locale] || {},
    (clientLanguage[locale]) || {}
  )
})

const initial = appTypes.APP_DEFAULT_LANGUAGE || 'es_ES'

// Reactive $ml object: replaces vue-multilanguage
const ml = reactive({
  current: initial,
  get (key, params) {
    const lang = mergedLanguages[this.current] || mergedLanguages[initial] || {}
    let value = lang[key]
    if (value === undefined) return key
    if (params) {
      if (Array.isArray(params)) {
        params.forEach((p, i) => { value = value.replace(`{${i}}`, p) })
      } else {
        Object.entries(params).forEach(([k, v]) => { value = value.replace(`{${k}}`, v) })
      }
    }
    return value
  },
  change (locale) {
    if (mergedLanguages[locale]) this.current = locale
  }
})

export default {
  install (app) {
    app.config.globalProperties.$ml = ml
  }
}

export { ml }
